module.exports = __webpack_public_path__ + "static/media/Flinks-red.a62412bf.png";